export const contrato = `<div style="text-align:justify;">
<div style="margin-bottom: 25px;">
        <h6 style="margin-top: 30px;">CONTRATANTE</h6>
        <div style="border: 1px solid #ccc; padding: 15px; margin-top: 10px; background-color: #f9f9f9;">
            <p style="margin: 5px 0;"><strong>Nome / Razão Social:</strong> {nome}</p>
            <p style="margin: 5px 0;"><strong>CPF/CNPJ:</strong> {cnpj}</p>
            <p style="margin: 5px 0;"><strong>Endereço:</strong> {endereco}</p>
        </div>
    </div>
  <hr>
 <div style="margin-bottom: 25px;">
        <h6 style="margin-top: 30px;">CONTRATADA</h6>
        <div style="border: 1px solid #ccc; padding: 15px; margin-top: 10px; background-color: #f9f9f9;">
            <p style="margin: 5px 0;"><strong>Nome / Razão Social:</strong> Soul Serviços Especializados E Tecnologia LTDA</p>
            <p style="margin: 5px 0;"><strong>CPF/CNPJ:</strong> 30.788.688/0001-87</p>
            <p style="margin: 5px 0;"><strong>Endereço:</strong> Rua Dr. Neto de Araújo, 320 - Vila Maria - São Paulo/SP</p>
        </div>
    </div>
<hr>

<h5>1 .Objeto do contrato</h5>
<p>1.1 O presente contrato tem como objeto registrar o fornecimento, pela
CONTRATADA à CONTRATANTE, os serviços de assessoria administrativa, fiscal e contábil, descritos no presente contrato como “Serviços”.</p>

<h5>2. Serviços</h5>
<p>2.1 A CONTRATADA prestará à CONTRATANTE os serviços de assessoria contábil,
fiscal e administrativa através do PLATAFORMA utilizada para a coleta,
armazenamento e gerenciamento das informações fornecidas pela
CONTRATANTE à CONTRATADA - Sistema Soul Tecnologia - composta pela seguinte
plataforma: Soul Tech</p>
<p>2.2 A Soul Tech fará coleta, armazenamento e processamento dos dados
fornecidos pela CONTRATANTE, bem como prestará os seguintes serviços
quando contratados:
<ol>
  <li>Elaboração de contratos de experiência de empregados</li>
  
  <li>Orientação da comunicação ao sindicato de admissão e demissão de empregados</li>
  
  <li>Processamento de folha e recibos de pagamento</li>
  
  <li>Cálculo de FGTS e INSS, e emissão das respectivas guias para pagamento</li>
  
  <li>Elaboração de documentos para homologação de rescisões trabalhistas</li>
  
  <li>Elaboração de recibos de férias</li>
  
  <li>Emissão de Guia de Contribuição Sindical de Empregado</li>
  
  <li>Emissão de comprovante de rendimento de empregado e empregador</li>
  
  <li>Assessoria nas exigências previstas na legislação fiscal e trabalhista</li>
  
  <li>Cálculo e emissão de guias de impostos, pró-labore e transmissão das obrigações acessórias por lei</li>
</ol>
</p>
<p>2.3 Além dos serviços descritos no item 2.2, a CONTRATADA poderá, mediante
solicitação da CONTRATANTE, prestar serviços NÃO INCLUÍDOS nos serviços
administrativos, fiscais e contábeis. A solicitação será feita através do chat
disponível na área do cliente e ou através de e-mail, após confirmação do
pagamento referente ao valor adicional. São considerados serviços não inclusos:

<ol type="i">
  <li>Abertura / Constituição de sociedades</li>
  <li>Alteração contratual / cadastral</li>
  <li>Desenquadramento / Enquadramento</li>
  <li>Consultoria com alvarás de funcionamento e licenciamento</li>
  <li>Encerramento da empresa</li>
  <li>Adicional por sócio</li>
  <li>Adicional por funcionário</li>
  <li>Serviços de motoboy</li>
  <li>RAIZ/DEFIS/REDARF – obrigações anteriores ao início da responsabilidade da CONTRATADA</li>
  <li>Certidões negativas do INSS, FGTS, Federais, ICMS e ISS</li>
  <li>Certidão negativa de falências ou protestos (de acordo com a região de atendimento)</li>
  <li>Declaração e retificação de IRPF e IRPJ</li>
  <li>Declaração de inatividade de PJ</li>
  <li>GFIP - obrigações anteriores ao início da responsabilidade da CONTRATADA</li>
  <li>Preenchimento de formulários</li>
  <li>Recálculo e reemissão de guias de impostos</li>
  <li>Alteração de folha de pagamento já processada</li>
  <li>Comprovante de faturamento</li>
  <li>Declaração de previsão de faturamento</li>
  <li>Planejamento tributário</li>
  <li>Cálculo e emissão do Recibo de Pagamento de Autônomo – RPA</li>
  <li>Cálculo e emissão de AIDF</li>
  <li>Emissão de nota fiscal de serviços ou comércio</li>
  <li>Solução de pendências de meses anteriores ao início da responsabilidade da CONTRATADA</li>
  <li>Parcelamento de débitos</li>
  <li>Consultoria trabalhista</li>
  <li>Criação de currículo</li>
  <li>Regularização do CPF</li>
  <li>Cálculo de rescisão pessoa física</li>
  <li>Consultoria para pessoa física</li>
</ol>
</p>
<p>2.4 A CONTRATANTE declara estar ciente que os serviços prestados pela
CONTRATADA, a partir da assinatura do presente contrato, limitam-se aos
descritos no item 2.2.
</p>
<p>2.5 As diligências junto a cartórios e órgãos públicos NÃO ESTÃO INCLUSAS no
contrato e poderão ser contratadas separadamente mediante consulta prévia.
</p>
<p>2.6  A CONTRATANTE declara estar ciente que toda atividade acrescida em
CONTRATO SOCIAL pela CONTRATADA é feita com base nas orientações por ela
fornecida.
</p>
<p>2.7  A CONTRATADA não se responsabiliza pelos entendimentos/interpretações que
possam ser dados por qualquer conselho representativo de classe ou órgão
regulatório quanto às atividades exercidas pela empresa.
</p>
<p>2.8 A CONTRATANTE declara-se estar ciente, no caso de possuir ou abrir filiais, que
deverá comunicar a CONTRATADA para verificar viabilidade da prestação de
serviços ora pretendidos e, se possível, realizar contrato adicional, ficando a
CONTRATADA no direito de avaliar as possibilidades de aceitar ou não. 
</p>


<h5>Dos serviços para empresas e comércio</h5>
<p>3.1  A empresa de COMÉRCIO declara que não está sujeita a qualquer vedação
quanto ao ingresso ou manutenção no Simples Nacional, nos termos do artigo
17, da Lei Complementar nº. 123/2006. Uma vez verificado pela CONTRATADA
qualquer vedação legal descrita na referida Lei, esta reserva-se ao direito de
rescindir o presente contrato, independente de qualquer notificação.
</p>
<p>3.2 A CONTRATADA reserva-se ainda, ao direito de rescindir o presente contrato no
caso de revisão do faturamento da CONTRATANTE, caso ultrapasse as condições
de manutenção no regime do Simples Nacional, observadas as condições
mencionadas no item 5.1 quanto à notificação.
</p>

<h5>4. Da utilização e uso do sistema </h5>
<p>4.1 A CONTRATANTE concorda e reconhece que o funcionamento adequado do
Sistema Soul Tech dependerá de sistemas operacionais e de infraestrutura, tais
como acesso a Internet e serviços de telecomunicações, fornecidos por terceiros,
cuja responsabilidade de contratação é exclusiva da CONTRATANTE, estando a
CONTRATADA isenta de qualquer responsabilidade pelo funcionamento
inadequado do Sistema Soul Tech.
</p>
<p>4.2 Não é de responsabilidade da CONTRATADA a conexão de banda larga para
acesso à Internet, sendo esta uma escolha da CONTRATANTE, a qual está ciente
que eventuais problemas na prestação desses serviços poderão impossibilitar o
pleno funcionamento do Sistema Soul Tech.</p>
<p>4.3 A CONTRATADA irá realizar o cadastro da CONTRATANTE no Sistema Soul Tech
. A CONTRATANTE declara que todas as informações fornecidas por
ela é verdadeira e válida e autoriza a CONTRATADA a acessar e fazer uso dessas
informações para todos os fins previstos neste Contrato. A CONTRATADA, por
sua vez, se compromete a não compartilhar as informações da CONTRATANTE
com terceiros e a fazer uso exclusivo dessas informações para prestação dos
serviços objeto deste Contrato.</p>
<p>4.4 O Sistema Soul Tech será acessado por meio de usuário e senha
disponibilizado pela CONTRATADA, sendo que o acesso às informações
disponibilizadas no sistema será gerenciada exclusivamente pela CONTRATANTE,
que será a única responsável pelas informações e pelo acesso às mesmas. A
CONTRATADA não se responsabiliza pelo acesso das informações da
CONTRATANTE por outras pessoas que não sejam usuários habilitados no
Sistema Soul Tech</p>

<h5>5. Vigência</h5>
<p>5.1 Este Contrato entra em vigor na data do seu aceite pela CONTRATANTE e terá
vigência de 12 (doze) meses, sendo renovado automaticamente por igual
período, salvo manifestação em contrário das partes, podendo, respeitando o
disposto no item 5.2 (abaixo), ser rescindido a qualquer tempo, por qualquer
uma das partes, mediante notificação prévia com 30 (trinta) dias de antecedência
da data em que a parte desejar rescindir o Contrato. A notificação deve ser
enviada por e-mail (financeiro@gruposoul.com.br). Serão devidos pela CONTRATANTE
todos os pagamentos vencidos e aqueles que vierem a vencer entre a data da
comunicação do interesse de uma parte em rescindir o Contrato e a data da sua
efetiva rescisão.</p>
<p>5.2 Caso a rescisão ocorra antes do 12º (DÉCIMO SEGUNDO) mês seguinte à data de
entrada em vigor do contrato (“PRIMEIRO ANIVERSÁRIO”), a CONTRATANTE
deverá pagar à CONTRATADA uma multa em valor equivalente a 40% (QUARENTA
POR CENTO) dos honorários vincendos entre a data da rescisão e a data do
primeiro aniversário.
</p>
<p>5.3 Caso a CONTRATANTE requeira o encerramento da empresa antes do período
mencionado no item 5.1, sem prejuízo do pagamento dos serviços adicionais e
dos serviços contábeis mensais efetivamente prestados até a completa baixa
regular da empresa, a CONTRATADA reserva-se ao direito de realizar a cobrança
da multa prevista no item acima, sendo o percentual aplicado aos honorários
vincendos desde a data efetiva da baixa até o 12º mês do contrato. A multa ora
mencionada não se aplicará para CONTRATANTE que requeira baixa após a
vigência de 12 (doze) meses de contrato.</p>
<p>5.4 A parte que rescindir o contrato sem enviar a outra parte a notificação prévia
prevista no item 5.1, ficará obrigada a pagar uma multa compensatória no valor
equivalente a 2 (duas) mensalidades vigente à época, além dos valores previstos
no item 5.2.</p>

<h5>Valores e forma de pagamento</h5>
<p>6.1 A CONTRATANTE pagará pelo Serviço da CONTRATADA os valores definidos no
momento da contratação, através do plano escolhido, o qual passará a integrar o
presente contrato. A CONTRATANTE declara estar ciente que os planos a serem
escolhidos por ela terão valores variáveis a depender dos seguintes critérios:
<ol type="I">
  <li>Forma de pagamento mensal ou anual</li>
  <li>Regime tributário</li>
  <li>Quantidade de sócios</li>
  <li>Quantidade de funcionários</li>
  <li>Faturamento</li>
</ol>
</p>
<p>6.2  A mudança de qualquer condição da CONTRATADA que afete a formação dos
honorários, conforme critérios previstos no item 6.1. e no plano escolhido no
momento da assinatura do presente contrato, alterará também o valor da
prestação de serviços.
</p>
<p>6.3 Os valores previstos no rol 6.1 acima poderão ser acrescidos de valores
adicionais conforme previsto nos itens 6.2, 6.6 e 6.7 deste Contrato.
</p>
<p>6.4 O Grupo SOul emitirá mensalmente à CONTRATANTE nota fiscal com a descrição
dos serviços prestados e com o valor devido pela CONTRATANTE sempre que os
valores forem liquidados e que for solicitado. Os valores devidos pela
CONTRATANTE serão pagos através de débito em cartão de crédito informado
pela CONTRATANTE no momento da realização do seu cadastro ou através de
boleto bancário, conforme a escolha da CONTRATANTE. Os pagamentos mensais
serão feitos sempre de forma adiantada e serão referentes aos serviços a serem
prestados no mês seguinte àquele em que o pagamento foi feito.
</p>
<p>6.5 Os honorários da CONTRATADA serão reajustados anualmente, tendo como base
a data de assinatura do Contrato, de acordo com a variação acumulada pelo
índice IGP-DI/FGV ou, na ausência dele, por qualquer outro que venha a
substituí-lo e que traduza uma correção adequada dos valores contratados.</p>
<p>6.6 Caso a CONTRATANTE tenha se beneficiado da gratuidade do serviço de abertura
de empresas e venha rescindir o contrato antes de decorrido o prazo previsto
para utilização dos créditos mencionados acima, o valor pago pelos serviços
previstos neste contrato não serão devolvidos, sem prejuízo da multa prevista no
item 5.2. A CONTRATANTE fica ciente que no caso de atraso de envios dos
documentos necessários para abertura da empresa, que resultar em prazo
superior a constituição que é de no máximo 30 dias, a CONTRATANTE pagará no
mês seguinte ao que completar 30 dias da assinatura do contrato, o valor
equivalente ao seu pacote de serviço, ou poderá ter seu contrato rescindindo a
critério da CONTRATADA</p>
<p>6.7 A inatividade da CONTRATANTE, não rescinde automaticamente o contrato e
nem cessa a obrigação de pagamento, a qual continuará obrigada a efetuar a
Soul Tech o pagamento mensal previsto na Cláusula 6.1 acima, tendo em vista
que em razão da manutenção de obrigações da CONTRATANTE perante os
órgãos municipal, estadual e federal, a CONTRATADA continuará a prestar a
CONTRATANTE os serviços. Caso a CONTRATANTE não tenha a intenção de
prosseguir com a prestação de serviços deverá comunicar a CONTRATADA na
forma prevista na Cláusula 5.1 acima, respeitadas as disposições dos itens 5.2 e
5.3.
</p>
<p>6.8  Os valores gastos com taxas de órgãos públicos e com materiais para execução
de serviços, tais como livros, correios, carimbos, pastas de arquivos, CDs, cópias
etc. serão antecipados pela CONTRATANTE.</p>
<p>6.9 A CONTRATANTE declara estar ciente que os valores descritos no presente
contrato não abrangem as taxas de junta comercial, prefeitura e/ou qualquer
outro órgão necessário ao regular funcionamento da empresa. Nesse sentido, a
CONTRATANTE é responsável pelo pagamento de toda e qualquer taxa a ser
paga perante todo e qualquer órgão sempre que necessário para o
funcionamento da empresa.
</p>
<p>6.10 A CONTRATANTE reconhece e concorda que o não pagamento mencionado na
presente Cláusula configura causa de rescisão contratual, gerando à
CONTRATADA o direito de rescindir o presente contrato sem prejuízo dos itens
5.1 e 5.2.</p>
<p>6.11 A CONTRATANTE concorda e confirma a possibilidade de envio de aviso sobre
atraso de pagamento via SMS ou outro meio de comunicação que facilite a
lembrança do pagamento através de informações inseridas junto ao Sistema
Soul Tech.
</p>
<p>6.12 Dos serviços não inclusos, cuja contratação é facultativa, exclui-se o serviço
obrigatório de fechamento de demonstrações contábeis, que inclui o diário e
seus respectivos demonstrativos, que são itens obrigatórios para o atendimento
do órgão de fiscalização. O valor poderá ser solicitado através dos meios de
comunicação da Soul Tech (chat, e-mail ou whatsApp).</p>

<p><strong>Mensalidade: </strong>{mensalidade}</p>

<h5>7. Inadimplamento e rescisão de contrato da contradada</h5>
<p>7.1 O não cumprimento do item 6 deste contrato tornará a parte CONTRATANTE
inadimplente. Os pagamentos efetuados após as datas de vencimento serão
acrescidos de multa moratória de até 2% (dois por cento) e juros de mora de
0,033% (zero vírgula zero trinta e três por cento) por dia de atraso.
</p>
<p>7.2 O inadimplemento após 30 dias, sujeitará a suspensão dos trabalhos, ficando a
CONTRATANTE sujeita as penalidades fiscais e tributárias decorrentes desta, a
título de multa por não entrega das obrigações acessórias tributárias. Antes de
suspender as entregas das obrigações acessórias o cliente será comunicado com
prazo de 72 horas, para as devidas providências.
</p>
<p>7.3 O inadimplemento da CONTRATANTE quanto ao pagamento de 3 (três)
mensalidades gera rescisão automática do presente contrato de prestação de
serviços pela CONTRATADA, independente da notificação prevista no item 5.1.</p>
<p>7.4  Após a rescisão da CONTRATANTE pelo motivo previsto no item 7.2, um novo
contrato de prestação de serviço será firmado apenas mediante regularização
dos períodos em que a CONTRATADA ficou sem contador responsável, com o
pagamento dos valores inerentes à regularização. A CONTRATANTE declara estar
ciente que os valores referentes à regularização são referentes à prestação de
serviços e não contemplam possíveis multas oriundas para regularização do
período sem contador responsável para os casos de reincidência da rescisão por
parte da CONTRATANTE, o retorno à plataforma e contratação dos serviços será
apenas mediante pagamento do plano anual.
</p>

<h5>8. Das obrigações</h5>
<p>8.1 A CONTRATADA, a partir da aceitação dos termos deste contrato pela
CONTRATANTE, comprometem-se a:
<ol>
<li>Prestar com zelo os serviços descritos no item 2, bem como quaisquer
outros que venha a ser prestado pela CONTRATADA;
</li>
<li>Realizar 3 (três) tentativas de contato com o contador responsável pelas
competências anteriores por meio eletrônico para solicitar os documentos
físicos ou digitais.
</li>
</ol>
</p>
<p>8.2 À partir da aceitação e adesão ao presente contrato, a CONTRATANTE
compromete-se a:
<ol type="I">
<li>
    Inserir ou informar dados necessários na plataforma para as devidas
apurações, tais como:
<ol>
    <li>Certificado Digital, código do simples, senha Sefaz/posto fiscal, senha
prefeitura;</li>
    <li>.Coletar documentos físicos ou digitais com o contador responsável pelas
competências anteriores e enviar à CONTRATADA digitalmente pela plataforma no
prazo de até 60 (sessenta) dias da adesão ao presente Contrato, em caso de
ausência de resposta e/ou insucesso pela CONTRATADA nos termos do item 8.1.
</li>
</ol>
</li>
  <li>
    Coletar documentos físicos ou digitais com o contador responsável pelas competências anteriores e enviar à CONTRATADA digitalmente pela plataforma no prazo de até 60 (sessenta) dias da adesão ao presente Contrato, em caso de ausência de resposta e/ou insucesso pela CONTRATADA nos termos do item 8.1.
  </li>

  <li>
    Enviar no prazo de 180 (cento e oitenta dias) todos os documentos necessários ao início da prestação dos serviços, ciente de que a responsabilidade técnica terá início quando da conclusão dos documentos enviados e de acordo com orientação da CONTRATADA.
  </li>

  <li>
    Providenciar mensalmente a documentação fiscal contábil descrita nos itens IV, V, VI e VIII, que deverá ser encaminhada pelo Sistema Soul Tech, impreterivelmente, até o 3º (terceiro) dia útil de cada mês.
  </li>

  <li>
    Caso a CONTRATANTE emita notas fiscais por talão físico, deverá realizar o registro manual de cada nota fiscal junto ao Sistema Soul Tech.
  </li>

  <li>
    A CONTRATANTE deverá emitir suas notas fiscais eletrônicas e importar as referidas notas no sistema caso não tenha Certificado Digital e-CNPJ.
  </li>

  <li>
    Importar para o Sistema da Soul Tech (área do cliente) o extrato bancário mensal.
  </li>

  <li>
    Anexar, através do Sistema Soul Tech (área do cliente), os comprovantes de pagamentos de impostos e demais despesas.  
    A indisponibilidade do Sistema Soul Tech não exclui a responsabilidade da CONTRATANTE de enviar os documentos, devendo eles serem remetidos para o e-mail soulcliente@Soul Tech.com.
  </li>

  <li>
    Respeitar todos os prazos indicados pela CONTRATADA para a correta prestação dos serviços contábeis ou pagar os valores referentes a processos de “reabertura” de prestação de serviços pelo não cumprimento de prazo.
  </li>

  <li>
    Utilizar a Plataforma Soul Tech como meio de comunicação entre as partes referentes à prestação de serviços.
  </li>

  <li>
    Enviar todo início de mês os pagamentos recebidos, impostos e tributos pagos e notas fiscais emitidas (quando não tiver certificado e-CNPJ – empresas do Simples Nacional Serviços).
  </li>

  <li>
    Fornecer antes do encerramento de cada exercício social a Carta de Responsabilidade da Administração, conforme artigo 2º da Resolução nº 987/03 do Conselho Federal de Contabilidade.
  </li>
</ol>
</p>
<p>8.3 As empresas no Simples Nacional Comércio e Lucro Presumido Serviços e
COMÉRCIO, deverão adquirir Certificado Digital modelo A1 para possibilitar a
entrega das obrigações fiscais e contábeis da CONTRATADA.
</p>
<p>8.4 A CONTRATANTE é responsável pelo correto arquivamento de todos os
documentos, incluindo comprovantes de despesas e notas fiscais recebidas</p>
<p>8.5 Nos casos em que houver pendências referentes à competências anteriores à
entrada em vigor deste contrato, a CONTRATANTE concorda que a CONTRATADA
cobre valores adicionais àqueles previsto no item 5.1. para resolver as
pendências, sendo que previamente à prática de qualquer ato, a CONTRATADA
enviará um orçamento para aprovação da CONTRATANTE.
</p>

<h5>9. Responsabilidade de administração da contratante</h5>
<p>9.1 No ato da aceitação e adesão ao presente contrato, o representante legal da
CONTRATANTE declara que as informações que serão fornecidas para
escrituração e elaboração das demonstrações contábeis, obrigações acessórias,
apuração de tributos e arquivos eletrônicos exigidos pela fiscalização federal,
estadual, municipal, trabalhista e previdenciária são verdadeiras.
</p>
<p>9.2 A CONTRATANTE é responsável pela veracidade de todas as informações
enviadas para a CONTRATADA.
</p>
<p>9.3 A CONTRATANTE declara não existirem quaisquer fatos ocorridos no período
base que afetam ou possam afetar as demonstrações contábeis ou, ainda, a
continuidade das operações da CONTRATANTE.
</p>
<p>9.4A CONTRATANTE declara que não realizou e nem realizará nenhum tipo de
operação que possa ser considerada ilegal, frente à legislação vigentebem como
não violou leis, normas ou regulamentos cujos efeitos deveriam ser considerados
para divulgação nas demonstrações contábeis, ou mesmo dar origem ao registro
de provisão para contingências passivas.
</p>


<h5>10. Disposições gerais</h5>
<p>10.1 No momento da contratação, a CONTRATANTE afirma estar ciente que a
CONTRATADA NÃO realiza atendimento de empresas que tenham atividades de
importação e exportação, razão pela qual declara não realizar tais atividades.
</p>
<p>10.2 A CONTRATANTE declara ser uma sociedade devidamente registrada junto aos
órgãos do município onde está localizada, junto à Receita Federal e prestar
somente os serviços que está autorizada a prestar em razão do seu objeto social
e se encontra estabelecida no endereço informado.
</p>
<p>10.3 Em caso de rescisão deste Contrato os documentos e Livros Contábeis da
CONTRATANTE só serão entregues a outro profissional após este cumprir as
formalidades do Distrato, de acordo com artigos 7º do Código de Ética
Profissional do Contador</p>
<p>10.4 As eventuais multas decorrentes da entrega de declarações fora do prazo legal e
pagamento de impostos atrasados, que forem decorrentes da não execução dos
serviços por parte da CONTRATADA, serão de responsabilidade desta </p>
<p>10.5 A CONTRATADA fica isenta do pagamento da multa prevista no item 11.3, caso a
mesma seja decorrente de atraso na entrega de documentos e declarações por
parte da CONTRATANTE ou entidades e pessoas externas que não sejam
empregados ou prestadores de serviços da CONTRATADA, bem como nos casos
em que não houver tempo hábil para a execução dos serviços e/ou a
CONTRATADA não estiverem de posse das informações e documentações
necessárias para realização da atividade.
</p>

<h5>Ausência de Vínculo</h5>
<p>11.1 Este Contrato não estabelece vínculo empregatício ou de representação entre
as partes, de forma que cada uma será responsável por suas próprias
obrigações e não poderão representar a outra em qualquer negócio jurídico</p>

<h5>12. Eleição de Foro e resolução de conflitos</h5>
<p>Fica eleito o foro da Comarca (........), São Paulo, para dirimir quaisquer dúvidas ou litígios
decorrentes deste contrato, renunciando expressamente a qualquer outro, mesmo que
privilegiado.
E por estarem de pleno acordo, justas e contratadas, após terem LIDO e ACEITO o
presente contrato, nada tendo a OPOR ou RESSALVAR, as partes firmam o presente
confirmando por meio de aceite eletrônico da CONTRATANTE. A versão eletrônica em
formato PDF estará disponível para download na plataforma Soul Tech (área
do cliente) após o aceite e cadastro dos dados da CONTRATANTE no sistema da
CONTRATADA.
</p>


</div>
`;